// extracted by mini-css-extract-plugin
export default {"DealsTabs__tabsList":"DealsTabs_DealsTabs__tabsList__ZTY2Y","DealsTabs__tab":"DealsTabs_DealsTabs__tab__ZGNjZ"};